import { AuthActions, AuthActionTypes } from '@app/auth/actions/auth';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';

export interface State {
  loggedIn: boolean;
  authError: boolean;
  user: any;
}

export const initialState: State = {
  loggedIn: false,
  authError: false,
  user: null
};

// Handlers
const userLoggedInHandler = (state, action) => ({
  ...state,
  user: action.payload,
  loggedIn: true,
  authError: false
});

const failureHandler = (state, action) => ({
  ...state,
  authError: true
});

const updateUserHandler = (state, action) => ({
  ...state,
  user: action.payload
});

const updateUserAddressHandler = (state, action) => ({
  ...state,
  user: R.mergeDeepRight(state.user, {
    address: action.payload
  })
});

const authSuccessHandler = createHandler([AuthActionTypes.LoginSuccess, AuthActionTypes.AuthenticatedSuccess], userLoggedInHandler);

const authFailureHandler = createHandler([AuthActionTypes.LoginFailure, AuthActionTypes.AuthenticatedFailure], failureHandler);

const changeCredentialsHandler = createHandler(AuthActionTypes.ChangeCredentials, (state) => ({
  ...state,
  authError: false
}));

const logoutHandler = createHandler(AuthActionTypes.Logout, () =>
  initialState
);

const updateAuthUserHandler = createHandler(AuthActionTypes.UpdateAuthUser, updateUserHandler);
const updateAuthUserAddressHandler = createHandler(AuthActionTypes.UpdateAuthUserAddress, updateUserAddressHandler);

export const reducer = createReducer<State, AuthActions>([
  authSuccessHandler,
  authFailureHandler,
  logoutHandler,
  updateAuthUserHandler,
  updateAuthUserAddressHandler,
  changeCredentialsHandler
], initialState);

// Selectors
export const getLoggedIn = (state: State) => state.loggedIn;

export const getAuthError = (state: State) => state.authError;

export const getUser = (state: State) => state.user;
